var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessStatus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.9999,
    cy: 25,
    rx: 25.0229,
    ry: 25,
    fill: "#1C6C2A",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5831 18.3492L24.9424 31.7184C23.8127 32.8622 21.8377 33.0941 20.7345 31.735L17.5087 27.7106C16.7575 26.7734 18.1928 25.5939 18.944 26.531L22.1655 30.5501C22.5656 30.9552 23.1088 30.9422 23.5066 30.5394L34.1438 17.1746C34.8918 16.2348 36.3311 17.4094 35.5831 18.3492Z",
    fill: "#1C6C2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessStatus);
export default __webpack_public_path__ + "static/media/success-status.a40be8216428ad0c5743f96ae6e303cb.svg";
export { ForwardRef as ReactComponent };